import React from 'react'
import './index.scss'

const CatalogTransferWelcome = () => (
    <div className="catalog-transfer-welcome">
        <h3>Welcome</h3>
        <h4>Catalog Transfer Process</h4>
        <p>
            The Catalog Transfer Tool will enable you to submit a request to transfer rights to works currently
            registered by another Member from their Catalog to yours. It typically takes users 15 minutes to complete
            and submit a transfer request using this tool. Your progress will be saved as you complete each step.
        </p>
        <div className="ct-before-you-begin">
            <p>
                <strong>Before you begin:</strong>
            </p>
            <p>
                Please make sure you have all the required documents below before getting started to ensure a smooth,
                efficient process.
            </p>
        </div>
        <div className="ct-required-documents">
            <h4>Required Information and Documents</h4>
            <div className="ct-required-documents-info">
                <strong>Please have the following information ready:</strong>
                <ul>
                    <li>Name of Catalog</li>
                    <li>Effective Date</li>
                    <li>Know if this is a full or partial works transfer</li>
                </ul>
                <br />
                <strong>Please have the following documents ready in digital format:</strong>
                <ul>
                    <li>Letter of Authorization*</li>
                    <li>Letter of Relinquishment (LOR)</li>
                </ul>
                <p className="ct-need-more-help">
                    To learn more about catalog transfers and The MLC’s catalog transfer process, please review our Help
                    Center article{' '}
                    <a
                        href="https://help.themlc.com/en/support/catalog-transfer-process-and-faqs"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        here.
                    </a>
                </p>
            </div>
        </div>
    </div>
)

export default CatalogTransferWelcome
